export default {"src":"/_next/static/media/export.af4bcf4a.svg","height":24,"width":24};